export enum PropertyStatus {
  available = "available",
  downloading = "downloading",
  finished = "finished",
  error = "error",
}
